export default "__VITE_ASSET__B5N9Epw___"